import { unreachableCaseError } from "@edgetier/utilities";
import { Sentiment } from "@edgetier/watchtower-types";
import { faAngry, faSmile, faThumbsUp } from "@fortawesome/free-regular-svg-icons";

/**
 * Get the props for the icon based on what sentiment is being displayed.
 * @param sentiment The sentiment being displayed.
 * @returns An object with the icon and className corresponding to the sentiment being displayed.
 */
export const getSentimentIconProps = (sentiment: Sentiment) => {
    switch (sentiment) {
        case Sentiment.Frustration:
            return { icon: faAngry, className: "sentiment-icon__has-frustration" };
        case Sentiment.Gratitude:
            return { icon: faSmile, className: "sentiment-icon__has-gratitude" };
        case Sentiment.Praise:
            return { icon: faThumbsUp, className: "sentiment-icon__has-praise" };
        default:
            throw unreachableCaseError(sentiment as never);
    }
};
